import { type IInternalContact } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type IInternalContactState } from './types';

export const SET_MATCHES = 'SET_MATCHES';

export const mutations: MutationTree<IInternalContactState> = {
    [SET_MATCHES](_state, { contactId, matches }: { contactId: number; matches: IInternalContact[] }) {
        _state.matches.set(contactId, matches);
    }
};
